import React from 'react'
import { Route } from 'react-router'
import { useTranslation } from 'react-i18next'

import config from './config'
import SectionHandler from 'components/SectionHandler'
import { SectionContainer } from './styled'

const SalesGroups = () => {
	const [t] = useTranslation()
	const sections = config(t)

	return(
		<SectionContainer>
			<Route path={`/:mainSection/kasse-global/:section/:id?`} render={routerProps => (
				<SectionHandler
					{...routerProps}
					sections={sections}
					sectionPathRedirect={true}
					replaceOnlyIdOnRoute={true}
					navBarProps={{ withoutTopMenu: true, hideLabel: true }}
					listFetchPolicy='cache-and-network'
				/>
			)}/>
		</SectionContainer>
	)
}

export default SalesGroups

